let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7u5Uq"), load("gLWJk")]).then(() => parcelRequire('5Idyr'));